import { BaseModel } from '@core/data-access';
import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class VerificationVerifyingModel extends BaseModel {
  @Expose() appId!: string;

  @Expose() last4NRIC!: string;

  @Expose() otpCode!: string;

  @Expose() verifyToken!: string;

  @Expose() maskPhone!: string;

  @Expose() sid!: string;
}
